import { useQuery, useMutation, useQueryClient } from "react-query";
import {
	getLookupsDistributionLists,
	getDistributionLists,
	getDistributionList,
	createDistributionList,
	updateDistributionList,
	deleteDistributionList,
} from "@/api/Maintainers/DistributionList/distribution-lists-api";

export const key = "distribution-lists";

export function useDistributionListsLookups() {
	return useQuery([key, "lookups"], () => getLookupsDistributionLists());
}

export function useDistributionLists(filters, options = {}) {
	return useQuery([key, "list", filters], () => getDistributionLists(filters), options);
}

export function useDistributionList(listId, options = {}) {
	return useQuery([key, "detail", listId], () => getDistributionList(listId), {
		...options,
		enabled: !!listId && (options.enabled !== undefined ? options.enabled : true),
	});
}

export function useCreateDistributionList() {
	const queryClient = useQueryClient();

	return useMutation(({ form, filters }) => createDistributionList(form, filters), {
		onSuccess: (data, variables) => {
			if (data?.data && variables.filters) {
				queryClient.setQueryData([key, "list", variables.filters], data);
			}
			queryClient.invalidateQueries([key, "detail"]);
		},
	});
}

export function useUpdateDistributionList() {
	const queryClient = useQueryClient();

	return useMutation(({ listId, form, filters }) => updateDistributionList(listId, form, filters), {
		onSuccess: (data, variables) => {
			if (data?.data && variables.filters) {
				queryClient.setQueryData([key, "list", variables.filters], data);
			}
			queryClient.invalidateQueries([key, "detail"]);
		},
	});
}

export function useDeleteDistributionList() {
	const queryClient = useQueryClient();

	return useMutation(deleteDistributionList, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}
